export default {
      id: "assignment-usage",
      viewBox: "0 0 35 44",
      url: __webpack_public_path__ + "sprite.6656901b3ab9be5618a76678ad156ea6.svg#assignment-usage",
      toString: function () {
        return this.url;
      }
    }